module.exports = __webpack_public_path__ + "img/4.8db27078.png";